import { Link } from 'react-router-dom';

export interface TabItem {
  key: string;
  label: string;
  to: string;
}

interface TabBarProps {
  tabs: TabItem[];
  activeKey: string;
  size: 'lg' | 'sm';
}

export function TabBar({ tabs, activeKey, size }: TabBarProps) {
  const isLg = size === 'lg';
  const containerClasses = isLg
    ? 'flex gap-6 border-b border-gray-200 dark:border-gray-700'
    : 'flex gap-4 py-1 border-b border-gray-200 dark:border-gray-700';
  const itemBase = isLg ? 'py-3 text-sm font-medium' : 'py-1.5 text-xs font-medium';
  const itemActive =
    'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400 -mb-px';
  const itemIdle =
    'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 border-b-2 border-transparent';

  return (
    <nav className={containerClasses} data-tabbar-size={size}>
      {tabs.map((t) => {
        const active = t.key === activeKey;
        return (
          <Link
            key={t.key}
            to={t.to}
            aria-current={active ? 'page' : undefined}
            className={`${itemBase} ${active ? itemActive : itemIdle}`}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
